import { createRoute, lazyRouteComponent } from "@tanstack/react-router";

const CalendarPage = lazyRouteComponent(() => import("@modules/calendar/pages/CalendarPage"), "CalendarPage");

export function getRoutes(parentRoute) {
  return [createRoute({ getParentRoute: () => parentRoute, path: "/calendar", component: CalendarPage })];
}
